export default function Button({
  as = "button",
  href,
  onClick,
  variant = "primary",
  size = "md",
  children,
  ...rest
}) {
  const Comp = as;

  const base = {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "10px",
    borderRadius: "5px",
    fontWeight: 750,
    border: "1px solid transparent",
    cursor: "pointer",
    textDecoration: "none",
    transition: "transform .12s ease, box-shadow .12s ease, background .12s ease",
    userSelect: "none",
    whiteSpace: "nowrap",
  };

  const sizes = {
    sm: { padding: "10px 12px", fontSize: "13px" },
    md: { padding: "12px 14px", fontSize: "13px" },
    lg: { padding: "14px 16px", fontSize: "14px" },
  };

  const variants = {
    primary: {
      background: "var(--cs-grad)",
      color: "#06131a",
      boxShadow: "0 10px 22px rgba(43,160,199,0.18)",
      borderColor: "rgba(255,255,255,0.12)",
    },
    dark: {
      background: "rgba(11,18,32,0.92)",
      color: "rgba(255,255,255,0.95)",
      borderColor: "rgba(255,255,255,0.12)",
    },
    outline: {
      background: "transparent",
      color: "rgba(11,18,32,0.90)",
      borderColor: "rgba(15,23,42,0.18)",
    },
    soft: {
      background: "rgba(43,160,199,0.12)",
      color: "rgba(11,18,32,0.90)",
      borderColor: "rgba(43,160,199,0.18)",
    },
  };

  const style = { ...base, ...sizes[size], ...variants[variant] };

  return (
    <Comp
      href={href}
      onClick={onClick}
      style={style}
      onMouseDown={(e) => {
        e.currentTarget.style.transform = "translateY(1px)";
      }}
      onMouseUp={(e) => {
        e.currentTarget.style.transform = "translateY(0)";
      }}
      {...rest}
    >
      {children}
    </Comp>
  );
}
